import { createTheme } from '@material-ui/core/styles';

import './default.scss';
import './fonts.scss';
import colors from '~/values/colors';
import 'react-toastify/dist/ReactToastify.css';

export default createTheme({
    typography: {
        fontFamily: 'Roboto, sans-serif',
    },
    palette: {
        primary: {
            main: colors.primary,
            50: '#F5F9E9',
            100: '#E5F1C8',
            200: '#D4E7A3 ',
            300: '#C3DD7E',
            400: '#B6D662',
            500: '#A9CF46',
            600: '#A2CA3F',
            700: '#98C337',
            800: '#8FBD2F',
            900: '#7EB220',
        },
        secondary: {
            main: colors.accent,
            50: '#E8E9EB',
            100: '#C5C8CC',
            200: '#9EA4AA',
            300: '#778088',
            400: '#5A646F',
            500: '#3D4955',
            600: '#37424E',
            700: '#2F3944',
            800: '#27313B',
            900: '#1A212A',
        },
    },
});
